import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import toast, { Toaster } from "react-hot-toast";
import Chart from "react-apexcharts";
import { getVisitTypeAM, getVisitByLocationAM, getDealerVisitAM, getPJPdataAM, getDealerVisitPerDayAM, getTimeSpentDealerAM } from "_controllers/officer";
import { useSelector } from "react-redux";

const AreaManagerDashboard = () => {
  const { user } = useSelector((state) => state.user);

  const [planned, setPlanned] = useState(0)
  const [unplanned, setUnplanned] = useState(0)
  const [totalVisits, setTotalVisits] = useState(0)

  const [lessThan100, setLessThan100] = useState(0)
  const [moreThan100, setMoreThan100] = useState(0)
  const [notCompleted, setNotCompleted] = useState(0)

  const [activeDealerVisits, setActiveDealerVisits] = useState(0)
  const [inactiveDealerVisits, setInactiveDealerVisits] = useState(0)
  const [activeDealers, setActiveDealers] = useState(0)

  const [uniqueVisits, setUniqueVisits] = useState(0)
  const [uniquetotalVisits, setUniqueTotalVisits] = useState(0)

  const [pjpData, setPjpData] = useState([])
  const [perDayVisitData, setPerDayVisitData] = useState([])
  const [dealerTimeSpent, setDealerTimeSpent] = useState([])

  const [loader1, setLoader1] = useState(true)
  const [loader2, setLoader2] = useState(true)
  const [loader3, setLoader3] = useState(true)
  const [loader4, setLoader4] = useState(true)
  const [loader5, setLoader5] = useState(true)
  const [loader6, setLoader6] = useState(true)

  const [hi, setHi] = useState({
    name: "shubhan",
    val: true
  })
  useEffect(() => {
    setHi({ ...hi, name: "sharma" })
  }, [])

  useEffect(() => {
    setHi({ ...hi, val: false })
  }, [])

  // console.log("hi", hi);

  useEffect(async () => {
    await getVisitTypeAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setPlanned(data?.plannedVisits)
      setUnplanned(data?.unplannedVisits)
      setTotalVisits(data?.totalVisits)
      setLoader1(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getVisitByLocationAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setLessThan100(data?.lessThan100)
      setMoreThan100(data?.moreThan100)
      setNotCompleted(data?.pendingVisits)
      setLoader2(false)
    }).catch((err) => console.log("err", err))

  }, []);

  useEffect(async () => {
    await getDealerVisitAM({
      // zone: user.regionCode,
      // startDate,
      // endDate,
    }).then((data) => {
      setUniqueVisits(data?.uniqueDealerVisits?.uniqueVisits)
      setUniqueTotalVisits(data?.uniqueDealerVisits?.totalVisits)
      setActiveDealers(data?.activeDealers)
      setActiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
        if (obj._id === "A") {
          acc += obj.count;
        }
        return acc;
      }, 0))
      setInactiveDealerVisits(data?.visitByDealerStatus.reduce((acc, obj) => {
        if (obj._id === "I") {
          acc += obj.count;
        }
        return acc;
      }, 0))
      // setLoading(false)
      setLoader3(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getPJPdataAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("pjp", data);
      setPjpData(data?.data)
      setLoader4(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getDealerVisitPerDayAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("dealer per day", data);
      setPerDayVisitData(data?.data)
      setLoader5(false)
    }).catch((err) => console.log("err", err))
  }, []);

  useEffect(async () => {
    await getTimeSpentDealerAM({
      // startDate,
      // endDate,
    }).then((data) => {
      console.log("time", data);
      setDealerTimeSpent(data?.data)
      setLoader6(false)
    }).catch((err) => console.log("err", err))
  }, []);

  // console.log("pjp", perDayVisitData);

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          border: "1px solid #eaeaea",
          margin: "1rem",
          width: "96.5%",
          borderRadius: "10px",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
        }}
      >
        <Grid item xs={12} md={12} xl={12}>
          <Typography align="center" variant="h4" sx={{ mt: 1, mb: 2.5 }}>
            AM DASHBOARD
          </Typography>
        </Grid>


        {/* <div style={{ border: "1px solid red", width: '50%', height: "50vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}> */}
        {loader1 === true ? (
          <CircularProgress />
        ) : (
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[planned, unplanned]}
              options={{
                labels: ["Planned", "Unplanned"],
                title: {
                  text: "Visit Type",
                  align: "center",
                },
                plotOptions: {
                  pie: {
                    startAngle: -90,
                    endAngle: 90,
                    // offsetY: 10,
                  },
                },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            ></Chart>
          </Grid>
        )}
        {/* </div> */}


        {loader3 === true ? (
          <CircularProgress />
        ) : (
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[activeDealerVisits, inactiveDealerVisits]}
              options={{
                labels: ["Active", "In-Active"],
                title: {
                  text: "Visit By Dealer Status",
                  align: "center",
                },
                plotOptions: {
                  pie: {
                    startAngle: -90,
                    endAngle: 90,
                    // offsetY: 10,
                  },
                },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </Grid>
        )}

        {loader3 === true ? (
          <CircularProgress />
        ) : (
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[
                uniqueVisits,
                uniquetotalVisits - uniqueVisits,
              ]}
              options={{
                labels: ["Unique Dealers Visits", "Repeated Dealers"],
                title: {
                  text: "Unique Dealer Visits.",
                  align: "center",
                },
                plotOptions: {
                  pie: {
                    startAngle: -90,
                    endAngle: 90,
                    // offsetY: 10,
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          // title: "jskjaksjksj",
                          formatter: function (val) {
                            return "Total Visits";
                          },
                        },
                        total: {
                          show: true,
                          formatter: function (val) {
                            return uniquetotalVisits ?? 100;
                          },
                        },
                      },
                    },
                  },
                },
                // yaxis: {
                //   labels: {},
                // },
                legend: {
                  position: "top",
                },
              }}
            />
          </Grid>
        )}

        {loader3 === true ? (
          <CircularProgress />
        ) : (
          // change static value of 1000
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[10000, activeDealers]}
              options={{
                labels: ["Unique Dealers", "Active Dealers"],
                title: {
                  text: "Total Visits/ Active Dealer Base",
                  align: "center",
                },
                plotOptions: {
                  pie: {
                    startAngle: -90,
                    endAngle: 90,
                    // offsetY: 10,
                  },
                },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </Grid>
        )}

        {loader2 === true ? (
          <CircularProgress />
        ) : (
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={[
                lessThan100,
                moreThan100,
                notCompleted,
              ]}
              options={{
                labels: ["Not-Ended", ">100m", "<100m"],
                title: {
                  text: "Visit By Start & End Location.",
                  align: "center",
                },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </Grid>
        )}

        {loader4 === true ? <CircularProgress /> :
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="bar"
              width={"100%"}
              height={"100%"}
              series={[
                {
                  name: "Count",
                  data: pjpData.map((p) => { return p?.count }),
                  // color: "greenyellow",
                },
                // {
                //   name: "NO",
                //   data: pjpData.map((p) => { return p?.value.notcreated }),
                // },
              ]}
              options={{
                labels: pjpData.map((p) => { return p?.user }),
                title: {
                  text: "PJP planning status.",
                  align: "center",
                },
                chart: {
                  toolbar: {
                    show: false, //Disable toolbar
                  },
                },
                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }
                },
                dataLabels: {
                  enabled: true,
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                },
                tooltip: { followCursor: true },
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "top",
                },
              }}
            />
          </Grid>
        }


        {loader5 === true ? <CircularProgress /> :
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="bar"
              width={"100%"}
              height={"100%"}
              series={[
                {
                  name: "Last Month",
                  data: perDayVisitData.map((p) => { return p?.value?.previousMonth }),
                  // color: "greenyellow",
                },
                {
                  name: "Current Month",
                  data: perDayVisitData.map((p) => { return p?.value?.currentMonth }),
                },
              ]}
              options={{
                labels: perDayVisitData.map((p) => { return p?.territory }),
                title: {
                  text: "Average Dealer Visits/Day.",
                  align: "center",
                },
                chart: {
                  toolbar: {
                    show: false, //Disable toolbar
                  },
                },
                legend: {
                  position: "top",
                },
                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }
                },
                dataLabels: {
                  enabled: true,
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                },
                stroke: {
                  show: true,
                  width: 3,
                  colors: ['transparent']
                },
                tooltip: { followCursor: true },
                yaxis: {
                  labels: {},
                },
              }}
            />
          </Grid>
        }


        {loader6 === true ? <CircularProgress /> :
          <Grid item xs={12} md={6} style={{ width: '50%', height: "400px" }}>
            <Chart
              type="bar"
              width={'100%'}
              height={'100%'}
              series={[
                {
                  name: "Last Month",
                  data: dealerTimeSpent.map((p) => { return p?.value === "NA" ? 0 : p?.value }),
                },
              ]}
              options={{
                labels: dealerTimeSpent.map((p) => { return p?.territory }),
                title: {
                  text: "Average Time Spent/Dealer (mins).",
                  align: "center",
                },
                chart: {
                  toolbar: {
                    show: false, //Disable toolbar
                  },
                },
                // plotOptions: {
                //   bar: {
                //     dataLabels: {
                //       position: 'top', // top, center, bottom
                //     },
                //   }
                // },
                // dataLabels: {
                //   enabled: true,
                //   offsetY: -20,
                //   style: {
                //     fontSize: '12px',
                //     colors: ["#304758"]
                //   }
                // },
                tooltip: { followCursor: true },
                yaxis: {
                  labels: {},
                },
              }}
            />
          </Grid>
        }


      </Grid>
    </>
  )
}

export default AreaManagerDashboard